export const getAssetsUrl = 'assets/';
export const getSearchAssetsUrl = 'search/assets/'; // by Core API
export const assetUrl = (assetId: string) => `assets/${assetId}/`;
export const assetDtcUrl = (assetId: string) => `assets/${assetId}/dtc/`;
